<div class="footer">
  <div class="flex items-center justify-center gap-4 h-full">
    <button
      (click)="approve()"
      *ngIf="isPending || isApproved"
      class="py-2 px-6 rounded-lg text-lg"
      [ngClass]="{
        'bg-green-500 text-white border-none': isPending,
        'bg-white text-green-500 border border-green-500': isApproved
      }"
    >
      <ng-container *ngIf="!isApproved; else approvedButton">Approve</ng-container>
      <ng-template #approvedButton>
        <div class="flex gap-2">Approved<ts-icon *ngIf="isApproved" [icon]="'check_circle'"></ts-icon></div>
      </ng-template>
    </button>
    <button
      (click)="decline()"
      *ngIf="isPending || isDeclined"
      class="py-2 px-6 rounded-lg text-lg"
      [ngClass]="{
        'bg-red-500 text-white border-none': isPending,
        'bg-white text-red-500 border border-red-500': isDeclined
      }"
    >
      <ng-container *ngIf="!isDeclined; else deniedButton">Decline</ng-container>
      <ng-template #deniedButton>
        <div class="flex gap-2">Declined<ts-icon *ngIf="isDeclined" [icon]="'cancel'"></ts-icon></div>
      </ng-template>
    </button>
  </div>
</div>
